import { Link, LinkProps } from '../Link';
import { styled } from '../styled';
import { Colors } from '../theme';

export const LinkStyled = styled(Link)<LinkProps>(({ theme }) => ({
  textDecoration: 'none',

  '.link-label': {
    color: Colors.blue500,
    transition: theme.transitions.create('color'),
  },

  '&:hover': {
    '.link-label': {
      color: Colors.blue700,
    },
  },

  '&:disabled': {
    cursor: 'default',

    '.link-label': {
      color: Colors.gray500,
    },
  },
}));
